import { useCallback, useState } from "react";
import { AiQuotaPaywallModalBase } from "../../../core/ai/AiQuotaPaywallModalBase";
import type { AiQuotaPaywallReason as AiQuotaReason } from "@superblocksteam/shared";

type AiQuotaPaywallModalProps = {
  open: boolean;
  reason: AiQuotaReason | undefined;
  onClose: () => void;
};

export const AiQuotaPaywallModal = ({
  open,
  reason,
  onClose,
}: AiQuotaPaywallModalProps) => {
  return (
    <AiQuotaPaywallModalBase
      open={open}
      reason={reason}
      onClose={onClose}
      analyticsSurface="ui"
    />
  );
};

export function useAiQuotaPaywall() {
  const [paywallState, setPaywallState] = useState<{
    open: boolean;
    reason: AiQuotaReason | undefined;
  }>({ open: false, reason: undefined });

  const showPaywall = useCallback((reason: AiQuotaReason | undefined) => {
    setPaywallState({ open: true, reason });
  }, []);

  const closePaywall = useCallback(() => {
    setPaywallState({ open: false, reason: undefined });
  }, []);

  return { paywallState, showPaywall, closePaywall };
}
